/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type SuggestedSearch = typeof SuggestedSearch[keyof typeof SuggestedSearch];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuggestedSearch = {
  'accountable-care-organizations': 'accountable-care-organizations',
  'agricultural-grades-and-standards': 'agricultural-grades-and-standards',
  'air-travel': 'air-travel',
  'airspace-classifications': 'airspace-classifications',
  'airworthiness-directives': 'airworthiness-directives',
  'americans-with-disabilities-act': 'americans-with-disabilities-act',
  'animal-drugs': 'animal-drugs',
  'arms-sales-notifications': 'arms-sales-notifications',
  'automated-commercial-environment-ace-': 'automated-commercial-environment-ace-',
  'automobile-safety-fuel-economy': 'automobile-safety-fuel-economy',
  'bank-secrecy-financial-crime-': 'bank-secrecy-financial-crime-',
  'broadband-policy': 'broadband-policy',
  'clean-air-act-state-implementation-plans': 'clean-air-act-state-implementation-plans',
  'climate-change': 'climate-change',
  'clinical-laboratory-improvement-program': 'clinical-laboratory-improvement-program',
  'commodity-promotion-agricultural-marketing': 'commodity-promotion-agricultural-marketing',
  'community-right-to-know': 'community-right-to-know',
  'continuation-of-health-benefits-cobra-': 'continuation-of-health-benefits-cobra-',
  'controlled-exports-ccl-usml-': 'controlled-exports-ccl-usml-',
  'controlled-substances': 'controlled-substances',
  'crop-insurance': 'crop-insurance',
  'cultural-objects-imported-for-exhibition': 'cultural-objects-imported-for-exhibition',
  'defense-federal-acquisition-regulation-supplement-dfars-': 'defense-federal-acquisition-regulation-supplement-dfars-',
  'denied-persons-specially-designated-nationals': 'denied-persons-specially-designated-nationals',
  'disaster-declarations-assistance': 'disaster-declarations-assistance',
  'dodd-frank-wall-steet-reform': 'dodd-frank-wall-steet-reform',
  'economic-sanctions-foreign-assets-control': 'economic-sanctions-foreign-assets-control',
  'education-department-grants-funding': 'education-department-grants-funding',
  'education-initiatives': 'education-initiatives',
  'electronic-health-information-technology': 'electronic-health-information-technology',
  'endangered-threatened-species': 'endangered-threatened-species',
  'energy-department-grants-funding': 'energy-department-grants-funding',
  'energy-efficiency-renewable-resources': 'energy-efficiency-renewable-resources',
  'federal-property-management': 'federal-property-management',
  'federal-travel-regulations': 'federal-travel-regulations',
  'fishery-management': 'fishery-management',
  'food-safety': 'food-safety',
  'food-substances-generally-recognized-as-safe': 'food-substances-generally-recognized-as-safe',
  'government-contracts': 'government-contracts',
  'health-and-human-services-grants-funding': 'health-and-human-services-grants-funding',
  'health-care-reform': 'health-care-reform',
  'housing-and-urban-development-department-grants-funding': 'housing-and-urban-development-department-grants-funding',
  'immigration-border-control': 'immigration-border-control',
  'information-collection-notices': 'information-collection-notices',
  'international-trade-anti-dumping-': 'international-trade-anti-dumping-',
  'meaningful-use-of-electronic-health-records': 'meaningful-use-of-electronic-health-records',
  'medical-devices': 'medical-devices',
  'medical-privacy-hipaa-': 'medical-privacy-hipaa-',
  'medicare-medicaid-and-schip-payments': 'medicare-medicaid-and-schip-payments',
  'migratory-bird-protection': 'migratory-bird-protection',
  'milk-marketing-orders': 'milk-marketing-orders',
  'national-environmental-policy-act': 'national-environmental-policy-act',
  'national-register-of-historic-places': 'national-register-of-historic-places',
  'native-american-remains-and-funerary-objects': 'native-american-remains-and-funerary-objects',
  'navigation-areas-safety-and-security-zones': 'navigation-areas-safety-and-security-zones',
  'north-american-free-trade-agreement-nafta-': 'north-american-free-trade-agreement-nafta-',
  'nutrition-assistance-programs': 'nutrition-assistance-programs',
  'oil-hazardous-substances-pollution-response': 'oil-hazardous-substances-pollution-response',
  'oil-and-gas-leasing': 'oil-and-gas-leasing',
  'outer-continental-shelf': 'outer-continental-shelf',
  'parks-recreation': 'parks-recreation',
  'patent-trademark-and-copyright': 'patent-trademark-and-copyright',
  'pesticide-tolerances': 'pesticide-tolerances',
  'pipeline-safety': 'pipeline-safety',
  'plant-protection-and-quarantine-': 'plant-protection-and-quarantine-',
  'ports-of-entry': 'ports-of-entry',
  'prevailing-rate-systems': 'prevailing-rate-systems',
  'preventing-collisions-at-sea-72-colregs-': 'preventing-collisions-at-sea-72-colregs-',
  'privacy-act-notices-regs': 'privacy-act-notices-regs',
  'product-safety': 'product-safety',
  'public-land-orders': 'public-land-orders',
  'quarterly-publication-of-individuals-who-have-chosen-to-expatriate': 'quarterly-publication-of-individuals-who-have-chosen-to-expatriate',
  'radio-television-broadcasting-services': 'radio-television-broadcasting-services',
  'regulatory-management-publication': 'regulatory-management-publication',
  'resource-conservation-and-recovery-act-rcra-': 'resource-conservation-and-recovery-act-rcra-',
  'sentencing-guidelines': 'sentencing-guidelines',
  'social-security-rulings-and-acquiescence-rulings': 'social-security-rulings-and-acquiescence-rulings',
  'standard-instrument-approach-procedures': 'standard-instrument-approach-procedures',
  'state-hazardous-waste-management-program': 'state-hazardous-waste-management-program',
  'stock-commodities-trading-': 'stock-commodities-trading-',
  'student-financial-aid': 'student-financial-aid',
  'taking-of-marine-mammals': 'taking-of-marine-mammals',
  'technical-barriers-to-trade-tbt-sps-agreements-': 'technical-barriers-to-trade-tbt-sps-agreements-',
  'toxic-substances-control': 'toxic-substances-control',
  'trade-adjustment-assistance': 'trade-adjustment-assistance',
  'transparency-open-government': 'transparency-open-government',
  'truth-in-lending-regulation-z-': 'truth-in-lending-regulation-z-',
  'underground-storage-tank-program': 'underground-storage-tank-program',
  'veterans-disability-ratings-claims': 'veterans-disability-ratings-claims',
  'veterans-educational-benefits': 'veterans-educational-benefits',
  'veterans-employment-training': 'veterans-employment-training',
  'veterinary-biologics-animal-disease': 'veterinary-biologics-animal-disease',
  'voting-elections': 'voting-elections',
} as const;
